export default __webpack_public_path__ + "static/screen-d346f1f0d32e6ff349e0cb4c166d139e.png";